import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Plus } from 'lucide-react';

/**
 * Floating Action Button (FAB) for quickly adding a new expense
 * Always visible at the bottom right of the screen (except on the new expense page)
 */
function FloatingAddButton() {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === '/expenses/new' || location.pathname === '/trips/new') {
    return null;
  }

  if (location.pathname.includes('/edit')) {
    return null;
  }

  const isTripsPage = location.pathname === '/trips';
  const destination = isTripsPage ? '/trips/new' : '/expenses/new';
  const label = isTripsPage ? 'New trip' : 'New expense';

  return (
    <button
      onClick={() => navigate(destination)}
      className="hidden md:flex fixed bottom-6 right-6 z-40 w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 items-center justify-center active:scale-95 group"
      aria-label={label}
    >
      <Plus className="w-7 h-7 transition-transform group-hover:rotate-90 duration-200" />

      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-1.5 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
        {label}
      </span>
    </button>
  );
}

export default FloatingAddButton;
